import React from "react";
import { Navigate } from "react-router-dom";
import { useApp } from "@/contexts/AppContext";
import { Loader2 } from "lucide-react";

export default function ProtectedUser({ children }) {
    const { user, authChecked } = useApp();
    if (!authChecked) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <Loader2 className="w-6 h-6 animate-spin text-accent" />
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
}
